import script from "./VTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./VTable.vue?vue&type=script&lang=ts&setup=true"

import "./VTable.vue?vue&type=style&index=0&id=16ec8195&lang=sass"

const __exports__ = script;

export default __exports__